module.exports = __webpack_public_path__ + "img/saham.305cb06d.png";